export const enum Trinary {
  On = 'On',
  Off = 'Off',
  Mixed = 'Mixed'
}
